import { render, staticRenderFns } from "./star-display.vue?vue&type=template&id=abe9fbb6&"
import script from "./star-display.vue?vue&type=script&lang=js&"
export * from "./star-display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abe9fbb6')) {
      api.createRecord('abe9fbb6', component.options)
    } else {
      api.reload('abe9fbb6', component.options)
    }
    module.hot.accept("./star-display.vue?vue&type=template&id=abe9fbb6&", function () {
      api.rerender('abe9fbb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8D6EPAoNB6BUy/JS/comp/star-display.vue"
export default component.exports